import "../assets/index-76dd9f11.css";
import { n } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const c = {
  name: "NcAppNavigationSpacer"
};
var t = function() {
  var a = this, e = a._self._c;
  return e("li", { staticClass: "app-navigation-spacer" });
}, _ = [], r = /* @__PURE__ */ n(
  c,
  t,
  _,
  !1,
  null,
  "c8233ec5",
  null,
  null
);
const i = r.exports;
export {
  i as default
};
